module.exports = __webpack_public_path__ + "assets/media/skip-forward.36d0d0d6.svg";